import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { colors, resolveColor, font } from "utils/styles";
import { valueOrDefault, checkColumnMode, screenSizes } from "utils/helpers";
import renderItem from "utils/renderItem";
import { useScreenSize } from "hooks";

export default function LeftRightFullHeight(props) {
	const { size } = useScreenSize();

	const [isColumn, setIsColumn] = useState(false);

	const sectionIndex = props.sectionIndex;
	const fields = props.data?.fields;

	const hashLink = fields?.hashLink;
	const justifyContainer = valueOrDefault(fields?.justifyContainer, "start");

	const leftSideHorizontalAlign = valueOrDefault(fields?.leftSideHorizontalAlign, "start");
	const leftSideVerticalAlign = valueOrDefault(fields?.leftSideVerticalAlign, "inherit");
	const leftSideAlignContent = valueOrDefault(fields?.leftSideAlignContent, "inherit");

	const rightSideHorizontalAlign = valueOrDefault(fields?.rightSideHorizontalAlign, "start");
	const rightSideVerticalAlign = valueOrDefault(fields?.rightSideVerticalAlign, "inherit");
	const rightSideAlignContent = valueOrDefault(fields?.rightSideAlignContent, "inherit");

	const leftColumnWidth = fields?.leftColumnWidth || { xs: 12, md: 6 };
	const rightColumnWidth = fields?.rightColumnWidth || { xs: 12, md: 6 };
	const leftInnerColumns = fields?.leftInnerColumns || {
		xs: 12,
	};
	const rightInnerColumns = fields?.rightInnerColumns || {
		xs: 12,
	};
	const isContainer = fields?.isContainer ? fields?.isContainer : false;
	const isWideContainer = fields?.isWideContainer ? fields?.isWideContainer : false;
	const leftVerticalPadding = fields?.leftVerticalPadding !== undefined ? fields?.leftVerticalPadding : 5;
	const rightVerticalPadding = fields?.rightVerticalPadding !== undefined ? fields?.rightVerticalPadding : 5;
	const leftSideClasses = fields?.leftSideClasses ? fields?.leftSideClasses : " ";
	const rightSideClasses = fields?.rightSideClasses ? fields?.rightSideClasses : " ";
	const outerWrapperClass = fields?.outerWrapperClass ? fields?.outerWrapperClass : " ";
	const outerLeftBackgroundColor = resolveColor(fields?.outerLeftBackgroundColor);
	const outerRightBackgroundColor = resolveColor(fields?.outerRightBackgroundColor);
	const reverse = fields?.reverse || props.reverse;
	const columnReverse = fields?.columnReverse || props.columnReverse;

	if (isContainer && isWideContainer) {
		console.warn("Shouldn't use both isContainer, and isWideContainer");
	}

	// const mdOrSmaller = sizeEqualOrLessThan("md");

	useEffect(() => {
		const isColumnMode = checkColumnMode(size, leftColumnWidth, rightColumnWidth, screenSizes);

		setIsColumn(isColumnMode);
	}, [size]);

	return (
		<div id={hashLink} className={`outerWrapper relative ${outerWrapperClass} fullHeightComponent`}>
			{(fields?.outerLeftBackgroundColor || fields?.outerRightBackgroundColor) && (
				<div className="row absolute g-0 w-100 h-100  ">
					<div className="col-6 outerLeftBackgroundColor"></div>
					<div className="col-6 outerRightBackgroundColor"></div>
				</div>
			)}
			<Container
				fluid
				className={`g-0 ${
					isContainer
						? `container-${isContainer}`
						: isWideContainer
						? `wide-container-${isWideContainer}`
						: " "
				}`}
			>
				{/* <div className="innerWrapper "> */}
				<Row
					className={` ${justifyContainer ? `justify-content-${justifyContainer}` : ""} ${
						isColumn && columnReverse
							? "flex-column"
							: isColumn
							? "flex-column-reverse"
							: reverse
							? "flex-row-reverse"
							: "flex-row"
					}  g-0`}
				>
					{/* Leftside */}
					<Col className="d-flex  " {...leftColumnWidth}>
						{/* <div className={`leftSide  py-${mdOrSmaller ? 0 : leftVerticalPadding} `}> */}
						<div
							className={`row leftSide-FH g-0 h-100 w-100 py-${leftVerticalPadding}  ${leftSideClasses} ${
								leftSideHorizontalAlign ? ` justify-content-${leftSideHorizontalAlign} ` : ""
							} ${leftSideVerticalAlign ? ` align-items-${leftSideVerticalAlign} ` : ""}
						 ${leftSideAlignContent ? ` align-content-${leftSideAlignContent} ` : ""}
						`}
						>
							{/* <Col className="    "> */}
							{/* <Row className={`leftSideClasses g-0  `}> */}
							{fields?.leftSide &&
								fields?.leftSide.map((item) => (
									<Col className="d-flex flex-column" key={item.sys.id} {...leftInnerColumns}>
										{/* <div> */}
										{renderItem(item, sectionIndex)}
										{/* </div> */}
									</Col>
								))}
							{!props.leftSide && !fields?.leftSide && <></>}
							{/* </Row> */}
							{/* </Col> */}
						</div>
						{/* </div> */}
					</Col>
					{/* Right side */}
					<Col className="d-flex " {...rightColumnWidth}>
						{/* <div className={`rightSide  py-${mdOrSmaller ? 0 : rightVerticalPadding} `}> */}
						<div
							className={`row rightSide-FH g-0 h-100 w-100 py-${rightVerticalPadding}  ${rightSideClasses} 
								${rightSideHorizontalAlign ? `justify-content-${rightSideHorizontalAlign}` : ""}
								${rightSideVerticalAlign ? `align-items-${rightSideVerticalAlign}` : ""}
								${rightSideAlignContent ? `align-content-${rightSideAlignContent}` : ""}
								`}
						>
							{/* <Col className="  "> */}
							{/* <Row className={` `}> */}
							{fields?.rightSide &&
								fields?.rightSide.map((item) => (
									<Col className="d-flex flex-column" key={item.sys.id} {...rightInnerColumns}>
										{renderItem(item, sectionIndex)}
									</Col>
								))}
							{!props.rightSide && !fields?.rightSide && <></>} {/* </Row> */}
							{/* </Col> */}
						</div>
						{/* </div> */}
					</Col>
				</Row>
				{/* </div> */}
			</Container>

			<style jsx="true">{`
				.outerLeftBackgroundColor {
					background-color: ${outerLeftBackgroundColor};
				}
				.outerRightBackgroundColor {
					background-color: ${outerRightBackgroundColor};
				}

				.outerWrapper {
					background: ${fields?.containerBackgroundColor
						? resolveColor(fields?.containerBackgroundColor)
						: "none"};
				}
				.leftSide-FH {
					z-index: 1;
					background: ${props.leftBgColor || resolveColor(fields?.leftBackgroundColor) || colors.white};
					width: -webkit-fill-available;
				}
				.rightSide-FH {
					z-index: 1;

					width: -webkit-fill-available;
					background: ${props.rightBgColor || resolveColor(fields?.rightBackgroundColor) || colors.white};
				}
			`}</style>
		</div>
	);
}
